module.exports = __webpack_public_path__ + "img/sect6-bg.9dfdbfcd.png";